export default __webpack_public_path__ + "static/media/student-work-12.5f13c3b3.jpeg";